import campaignGroupsRepository from '@/services/repositories/campaign-groups-repository'
import handleErrors from '@/services/handleErrors'

const actions = {
  async fetchCampaignGroups() {
    this.campaignGroupsAreLoading = true
    try {
      const response = await campaignGroupsRepository.index()
      this.campaignGroups = response
    } catch (error) {
      handleErrors(error)
    }
    this.campaignGroupsAreLoading = false
  },
  setCampaignGroupId(value) {
    this.groupId = value
  }
}

export default actions
